import { redirectToLogin } from './navigation';
import { clearSession } from './session';

const OVERLAY_ID = 'session-expired-overlay';
const TITLE_ID = 'session-expired-title';
const DISMISS_BUTTON_ID = 'session-expired-dismiss';
const REDIRECT_DELAY_MS = 5000;

/**
 * React equivalent of the AngularJS $httpInterceptor responseError handler
 * (www/app/app.js) that ran on every 401: it clears the session, shows a
 * generic message, then hands navigation back to the login page.
 */
export function handleSessionExpired(): void {
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return;
  }

  if (document.getElementById(OVERLAY_ID)) {
    return;
  }

  clearSession();
  showSessionExpiredOverlay();

  window.setTimeout(redirectToLogin, REDIRECT_DELAY_MS);
}

function showSessionExpiredOverlay(): void {
  const overlay = document.createElement('div');
  overlay.id = OVERLAY_ID;
  overlay.setAttribute('role', 'alertdialog');
  overlay.setAttribute('aria-modal', 'true');
  overlay.setAttribute('aria-labelledby', TITLE_ID);
  overlay.style.cssText =
    'position:fixed;top:0;left:0;height:100%;width:100%;background:rgba(0, 0, 0, 0.7);z-index:2147483647;display:flex;align-items:center;justify-content:center;';

  overlay.innerHTML =
    '<div style="background:#fff;border-radius:8px;box-shadow:0 3px 3px rgba(0, 0, 0, .3);padding:25px;width:550px;max-width:90%;text-align:center;">' +
    `<h3 id="${TITLE_ID}" style="text-transform:uppercase;font-weight:bold;margin-top:0;">Session Expired</h3>` +
    '<p style="margin-bottom:15px;">Your session has expired. Please log in again.</p>' +
    '<div style="display:flex;justify-content:center;gap:10px;padding-bottom:15px;border-bottom:5px solid #FF471A;">' +
    `<button type="button" id="${DISMISS_BUTTON_ID}" style="background-color:#FFD24C;color:#1E1E1E;border:none;border-radius:4px;padding:8px 20px;min-width:75px;cursor:pointer;">Log In Now</button>` +
    '</div>' +
    '</div>';

  document.body.appendChild(overlay);

  document.getElementById(DISMISS_BUTTON_ID)?.addEventListener('click', redirectToLogin);
}
